export default {
  en: {
    types: { promotion: "Promotion", ivr: "IVR", agent: "Agent" },
    status: { active: "Active", inactive: "Inactive", completed: "Completed" },
    empty_state: "No campaigns yet. Create one to get started.",
    no_results: "No campaigns match your filters.",
    toolbar: {
      search: "Search campaigns",
      filter_all: "All statuses",
      filter_active: "Active",
      filter_inactive: "Inactive",
      filter_completed: "Completed",
      refresh: "Refresh",
      create: "New Campaign",
      view_cards: "Cards view",
      view_table: "Table view",
      manage_sounds: "Manage sounds",
    },
    stats: {
      total: "Total",
      active: "Active",
      inactive: "Inactive",
      completed: "Completed",
    },
    card: {
      attempts: "Attempts",
      calls_per_batch: "Calls/batch",
      ring_duration: "Ring",
      seconds_short: "s",
    },
    actions: {
      activate: "Activate",
      deactivate: "Deactivate",
      edit: "Edit",
      reports: "Reports",
      delete: "Delete",
      delete_started: "A campaign that has already started can't be deleted",
      completed_locked: "This campaign has finished — it can't be changed",
    },
    reports: {
      title: "Campaign Reports",
      subtitle: "Dial outcomes and call records.",
      subtitle_ivr: "Dial outcomes, IVR responses and call records.",
      back: "Back to campaigns",
      refresh: "Refresh",
      retry: "Retry",
      empty: "No report data for this campaign yet.",
      kpi_attempts: "Attempts",
      kpi_numbers: "Numbers",
      kpi_answer_rate: "Answer rate",
      kpi_avg_talk: "Avg talk time",
      kpi_responses: "IVR responses",
      status_title: "Attempt outcomes",
      status_empty: "No dial outcomes recorded yet.",
      attempts_title: "Dial attempts",
      attempts_empty: "No dial attempts recorded yet.",
      att_phone: "Number",
      att_attempt: "Attempt",
      att_status: "Outcome",
      att_queued: "Queued",
      att_started: "Started",
      att_ended: "Ended",
      ivr_title: "IVR responses",
      ivr_empty: "No IVR responses recorded yet.",
      cdr_title: "Call records",
      cdr_empty: "No call records returned for this campaign.",
      cdr_agent: "Agent",
      cdr_status: "Status",
      cdr_start: "Started",
      cdr_answer: "Answered",
      cdr_end: "Ended",
      cdr_total: "Total",
      cdr_talk: "Talk time",
    },
    confirm: {
      delete_title: "Delete Campaign",
      delete_text: 'Delete campaign "{name}" and all its contacts?',
      delete_btn: "Delete",
      cancel_btn: "Cancel",
    },
    messages: {
      created: "Campaign created",
      updated: "Campaign updated",
      deleted: "Campaign deleted",
      status_changed: "Campaign status updated",
    },
    table: {
      head_name: "Name",
      head_type: "Type",
      head_dates: "Dates",
      head_hours: "Hours",
      head_attempts: "Attempts",
      head_batch: "Calls/Batch",
      head_ring: "Ring",
      head_status: "Status",
      head_actions: "Actions",
    },
    dialog: {
      create_title: "New Campaign",
      edit_title: "Edit Campaign",
      name: "Name",
      type: "Type",
      type_locked: "Type can't be changed after creation",
      caller_id: "Caller ID",
      caller_id_placeholder: "Select a caller ID",
      locked: "This campaign has already started or is about to start, so it can no longer be edited.",
      active_label: "Active",
      start_day: "Start date",
      end_day: "End date",
      start_time: "Start time",
      end_time: "End time",
      attempts: "Attempts per contact",
      calls_per_batch: "Calls per batch",
      ring_duration: "Ring duration (seconds)",
      config_title: {
        promotion: "Promotion message",
        ivr: "IVR menu",
        agent: "Assigned agents",
      },
      sound: "Sound to play",
      sound_placeholder: "Select a sound",
      prompt: "Menu prompt sound",
      options: "Menu options",
      add_option: "Add option",
      digit: "Key",
      option_label: "Label",
      option_sound: "Sound",
      agents: "Agents",
      add_agent: "Add agent",
      pick_agent: "Add from users",
      agent_name: "Name",
      agent_extension: "Extension",
      csv: "Contacts (CSV)",
      csv_placeholder: "No file selected",
      csv_choose: "Choose CSV",
      csv_hint: "Optional: a CSV of phone numbers to dial",
      csv_replace_warning: "Uploading a CSV replaces ALL existing contacts.",
      cancel_btn: "Cancel",
      create_btn: "Create Campaign",
      save_btn: "Save Changes",
    },
    validation: {
      name_required: "Name is required",
      caller_id_required: "Pick a caller ID",
      start_day_required: "Start date is required",
      start_too_soon: "Start must be at least 5 minutes from now",
      end_day_required: "End date is required",
      end_after_start: "End date must be after the start date",
      hours_required: "Start and end times are required",
      end_hour_after_start: "End time must be after the start time",
      attempts_invalid: "Attempts must be a whole number of 1 or more",
      calls_per_batch_invalid: "Calls per batch must be 1 or more",
      ring_duration_invalid: "Ring duration must be 1 second or more",
      sound_required: "Pick the sound to play",
      prompt_required: "Pick the menu prompt sound",
      options_required: "Add at least one menu option",
      options_incomplete: "Each option needs a key (0-9, * or #), a label and a sound",
      options_digits_unique: "Menu keys must be unique",
      agents_required: "Add at least one agent",
      agents_incomplete: "Each agent needs a name and an extension",
      file_type: "Contacts file must be a .csv",
      csv_required: "A CSV of phone numbers is required when creating a campaign",
    },
    sounds: {
      title: "Campaign Sounds",
      description: "Audio files used as campaign messages and IVR prompts.",
      back: "Back to campaigns",
      upload_btn: "Upload Sound",
      search: "Search sounds",
      empty: "No sounds uploaded yet",
      head_name: "Name",
      head_actions: "Actions",
      play: "Play / stop",
      upload_title: "Upload Sound",
      edit_title: "Edit Sound",
      name_label: "Name",
      name_invalid: "Name must be 2-100 characters",
      file_label: "Audio file (mp3 / wav)",
      replace_file_label: "Replace audio file (optional)",
      file_placeholder: "No file selected",
      file_choose: "Choose file",
      replace_file_hint: "Leave empty to keep the current audio",
      save_btn: "Save",
      uploaded: "Sound uploaded",
      updated: "Sound updated",
      deleted: "Sound deleted",
      delete_title: "Delete Sound",
      delete_text: 'Delete sound "{name}"? Campaigns using it may stop working.',
      delete_confirm: "Delete",
      delete_cancel: "Cancel",
    },
  },
  ar: {
    types: { promotion: "رسالة ترويجية", ivr: "رد آلي", agent: "موظف" },
    status: { active: "نشطة", inactive: "متوقفة", completed: "مكتملة" },
    empty_state: "لا توجد حملات بعد. أنشئ حملة للبدء.",
    no_results: "لا توجد حملات مطابقة للتصفية.",
    toolbar: {
      search: "ابحث في الحملات",
      filter_all: "كل الحالات",
      filter_active: "نشطة",
      filter_inactive: "متوقفة",
      filter_completed: "مكتملة",
      refresh: "تحديث",
      create: "حملة جديدة",
      view_cards: "عرض البطاقات",
      view_table: "عرض الجدول",
      manage_sounds: "إدارة الملفات الصوتية",
    },
    stats: {
      total: "الإجمالي",
      active: "نشطة",
      inactive: "متوقفة",
      completed: "مكتملة",
    },
    card: {
      attempts: "المحاولات",
      calls_per_batch: "مكالمات/دفعة",
      ring_duration: "الرنين",
      seconds_short: "ث",
    },
    actions: {
      activate: "تفعيل",
      deactivate: "إيقاف",
      edit: "تعديل",
      reports: "التقارير",
      delete: "حذف",
      delete_started: "لا يمكن حذف حملة بدأت بالفعل",
      completed_locked: "هذه الحملة انتهت — لا يمكن تعديلها",
    },
    reports: {
      title: "تقارير الحملة",
      subtitle: "نتائج الاتصال وسجلات المكالمات.",
      subtitle_ivr: "نتائج الاتصال وردود الرد الصوتي وسجلات المكالمات.",
      back: "الرجوع إلى الحملات",
      refresh: "تحديث",
      retry: "إعادة المحاولة",
      empty: "لا توجد بيانات تقارير لهذه الحملة بعد.",
      kpi_attempts: "المحاولات",
      kpi_numbers: "الأرقام",
      kpi_answer_rate: "نسبة الرد",
      kpi_avg_talk: "متوسط مدة التحدث",
      kpi_responses: "ردود الرد الصوتي",
      status_title: "نتائج المحاولات",
      status_empty: "لا توجد نتائج اتصال مسجّلة بعد.",
      attempts_title: "محاولات الاتصال",
      attempts_empty: "لا توجد محاولات اتصال مسجّلة بعد.",
      att_phone: "الرقم",
      att_attempt: "المحاولة",
      att_status: "النتيجة",
      att_queued: "في الانتظار",
      att_started: "البداية",
      att_ended: "النهاية",
      ivr_title: "ردود الرد الصوتي",
      ivr_empty: "لا توجد ردود مسجّلة بعد.",
      cdr_title: "سجلات المكالمات",
      cdr_empty: "لم تُرجع أي سجلات مكالمات لهذه الحملة.",
      cdr_agent: "الموظف",
      cdr_status: "الحالة",
      cdr_start: "البداية",
      cdr_answer: "وقت الرد",
      cdr_end: "النهاية",
      cdr_total: "المدة الكلية",
      cdr_talk: "مدة التحدث",
    },
    confirm: {
      delete_title: "حذف الحملة",
      delete_text: "هل تريد حذف الحملة «{name}» مع جميع أرقامها؟",
      delete_btn: "حذف",
      cancel_btn: "إلغاء",
    },
    messages: {
      created: "تم إنشاء الحملة",
      updated: "تم تحديث الحملة",
      deleted: "تم حذف الحملة",
      status_changed: "تم تحديث حالة الحملة",
    },
    table: {
      head_name: "الاسم",
      head_type: "النوع",
      head_dates: "التواريخ",
      head_hours: "الأوقات",
      head_attempts: "المحاولات",
      head_batch: "مكالمات/دفعة",
      head_ring: "الرنين",
      head_status: "الحالة",
      head_actions: "الإجراءات",
    },
    dialog: {
      create_title: "حملة جديدة",
      edit_title: "تعديل الحملة",
      name: "الاسم",
      type: "النوع",
      type_locked: "لا يمكن تغيير النوع بعد الإنشاء",
      caller_id: "هوية المتصل",
      caller_id_placeholder: "اختر هوية المتصل",
      locked: "لا يمكن تعديل هذه الحملة لأنها بدأت بالفعل أو على وشك البدء.",
      active_label: "نشطة",
      start_day: "تاريخ البداية",
      end_day: "تاريخ النهاية",
      start_time: "وقت البداية",
      end_time: "وقت النهاية",
      attempts: "عدد المحاولات لكل رقم",
      calls_per_batch: "عدد المكالمات في الدفعة",
      ring_duration: "مدة الرنين (ثانية)",
      config_title: {
        promotion: "الرسالة الترويجية",
        ivr: "قائمة الرد الآلي",
        agent: "الموظفون المعينون",
      },
      sound: "الملف الصوتي",
      sound_placeholder: "اختر ملفًا صوتيًا",
      prompt: "صوت قائمة الخيارات",
      options: "خيارات القائمة",
      add_option: "إضافة خيار",
      digit: "الزر",
      option_label: "الوصف",
      option_sound: "الصوت",
      agents: "الموظفون",
      add_agent: "إضافة موظف",
      pick_agent: "إضافة من المستخدمين",
      agent_name: "الاسم",
      agent_extension: "التحويلة",
      csv: "الأرقام (ملف CSV)",
      csv_placeholder: "لم يتم اختيار ملف",
      csv_choose: "اختر ملف CSV",
      csv_hint: "اختياري: ملف CSV بأرقام الهواتف",
      csv_replace_warning: "رفع ملف CSV سيستبدل جميع الأرقام الحالية.",
      cancel_btn: "إلغاء",
      create_btn: "إنشاء الحملة",
      save_btn: "حفظ التغييرات",
    },
    validation: {
      name_required: "الاسم مطلوب",
      caller_id_required: "اختر هوية المتصل",
      start_day_required: "تاريخ البداية مطلوب",
      start_too_soon: "يجب أن يكون وقت البدء بعد 5 دقائق على الأقل من الآن",
      end_day_required: "تاريخ النهاية مطلوب",
      end_after_start: "يجب أن يكون تاريخ النهاية بعد تاريخ البداية",
      hours_required: "وقتا البداية والنهاية مطلوبان",
      end_hour_after_start: "يجب أن يكون وقت النهاية بعد وقت البداية",
      attempts_invalid: "عدد المحاولات يجب أن يكون عددًا صحيحًا 1 أو أكثر",
      calls_per_batch_invalid: "عدد المكالمات في الدفعة يجب أن يكون 1 أو أكثر",
      ring_duration_invalid: "مدة الرنين يجب أن تكون ثانية واحدة أو أكثر",
      sound_required: "اختر الملف الصوتي",
      prompt_required: "اختر صوت قائمة الخيارات",
      options_required: "أضف خيارًا واحدًا على الأقل",
      options_incomplete: "كل خيار يحتاج إلى زر (0-9 أو * أو #) ووصف وملف صوتي",
      options_digits_unique: "أزرار القائمة يجب ألا تتكرر",
      agents_required: "أضف موظفًا واحدًا على الأقل",
      agents_incomplete: "كل موظف يحتاج إلى اسم وتحويلة",
      file_type: "ملف الأرقام يجب أن يكون بصيغة ‎.csv",
      csv_required: "ملف CSV بأرقام الهواتف مطلوب عند إنشاء الحملة",
    },
    sounds: {
      title: "الملفات الصوتية للحملات",
      description: "الملفات الصوتية المستخدمة كرسائل للحملات وقوائم الرد الآلي.",
      back: "العودة إلى الحملات",
      upload_btn: "رفع ملف صوتي",
      search: "ابحث في الملفات الصوتية",
      empty: "لا توجد ملفات صوتية بعد",
      head_name: "الاسم",
      head_actions: "الإجراءات",
      play: "تشغيل / إيقاف",
      upload_title: "رفع ملف صوتي",
      edit_title: "تعديل الملف الصوتي",
      name_label: "الاسم",
      name_invalid: "الاسم يجب أن يكون بين 2 و100 حرف",
      file_label: "الملف الصوتي (mp3 / wav)",
      replace_file_label: "استبدال الملف الصوتي (اختياري)",
      file_placeholder: "لم يتم اختيار ملف",
      file_choose: "اختر ملفًا",
      replace_file_hint: "اتركه فارغًا للاحتفاظ بالملف الحالي",
      save_btn: "حفظ",
      uploaded: "تم رفع الملف الصوتي",
      updated: "تم تحديث الملف الصوتي",
      deleted: "تم حذف الملف الصوتي",
      delete_title: "حذف الملف الصوتي",
      delete_text: "هل تريد حذف الملف الصوتي «{name}»؟ قد تتأثر الحملات التي تستخدمه.",
      delete_confirm: "حذف",
      delete_cancel: "إلغاء",
    },
  },
};
